import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardHeader, CardContent, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Alert, AlertDescription } from './ui/alert';
import { useAuth } from '../AuthContext';

export const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <div className="flex items-center gap-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_roomreserve-46/artifacts/ogw5o67w_cropped-Logo-med-hvid-baggrund-90x90.png" 
                alt="Gymnastik Logo" 
                style={{ height: '48px', width: '48px' }}
                className="object-contain"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_roomreserve-46/artifacts/pzd8lr16_MG_%26_BK_logo_136.png" 
                alt="MG & BK Logo" 
                className="h-12 object-contain"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_roomreserve-46/artifacts/h1gpmvyf_RUB_logo_Siden_1989_CMYK.jpg" 
                alt="Rock Under Broen Logo" 
                className="h-12 object-contain"
              />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent">
            Log ind på booking system
          </CardTitle>
          <p className="text-slate-600 text-sm mt-2">
            Log ind for at få adgang til mødelokale booking systemet
          </p>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <Alert className="border-red-200 bg-red-50">
                <AlertDescription className="text-red-800">{error}</AlertDescription>
              </Alert>
            )}
            
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="din@email.dk"
                required
                disabled={loading}
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="password">Adgangskode</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>
            
            <Button 
              type="submit" 
              className="w-full bg-blue-600 hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? 'Logger ind...' : 'Log ind'}
            </Button>
          </form>
          
          <div className="mt-6 p-4 bg-slate-50 rounded-lg border">
            <p className="text-xs text-slate-600 text-center">
              Har du ikke adgang? Kontakt en administrator for at få en invitation.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};